import Header from "./Header.blog";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Footer = () => {
    return (
        <footer className="blog-footer">
            <div className="blog-footer__container">
                <Header className='blog-header blog-header--scrolled' forceCompact />
                <div className="row mb-5">
                    <div className="col-md-4">
                        <h4 className="blog-footer__title">Sobre nosotros</h4>
                        <div className="blog-icons text-white">
                            <a
                                href="https://facebook.com/tupagina"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-icon"
                                aria-label="Facebook"
                            >
                                <FacebookIcon className="pointer" />
                            </a>
                            <a
                                href="https://instagram.com/tupagina"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-icon"
                                aria-label="Instagram"
                            >
                                <InstagramIcon />
                            </a>
                            <a
                                href="https://youtube.com/tupagina"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="blog-icon"
                                aria-label="YouTube"
                            >
                                <YouTubeIcon />
                            </a>

                        </div>


                    </div>

                    <div className="col-md-4">
                        <h4 className="blog-footer__title">SAFIBC</h4>

                        <ul className="blog-footer__links">
                            <li>
                                <a href="/">Inicio</a>
                            </li>
                            <li>
                                <a href="/sobre-nosotros">Sobre nosotros</a>
                            </li>
                            <li>
                                <a href="/contacto">Contáctanos</a>
                            </li>
                        </ul>
                    </div>


                </div>
            </div>
        </footer>
    );
};

export default Footer;